import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=e24cfada&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=e24cfada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24cfada",
  null
  
)

export default component.exports